import React from 'react';
import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../Pages/Style.css'; // Adjust path if needed

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

import 'bootstrap/dist/css/bootstrap.min.css';


const Home = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,  // animation time in ms
            once: true,      // animate only once when scrolling down
            easing: 'ease-in-out',
            offset: 120,
        });
    }, []);
    return (
        <div id='content' >
            <div id="imageCarousel" className="carousel slide" data-bs-ride="carousel" data-bs-interval="2000">
                <div className="carousel-inner">

                    <div className="carousel-item active">
                        <img
                            src="/Photos/researchers-looking-alternative-energy-souces.jpg"
                            className="d-block w-100"
                            alt="Slide 1"
                            style={{ height: '600px', objectFit: 'cover', objectPosition: 'top' }}
                        />

                    </div>

                    <div className="carousel-item">
                        <img
                            src="/Photos/group-diverse-people-having-business-meeting.jpg"
                            className="d-block w-100"
                            alt="Slide 2"
                            style={{ height: '600px', objectFit: 'cover', objectPosition: 'top' }}
                        />
                    </div>

                    <div className="carousel-item">
                        <img
                            src="/Photos/businesspeople-listening-boss.jpg"
                            className="d-block w-100"
                            alt="Slide 3"
                            style={{ height: '600px', objectFit: 'cover', objectPosition: 'top' }}
                        />
                    </div>

                    <div className="carousel-item">
                        <img
                            src="/Photos/modern-equipped-computer-lab11.jpg"
                            className="d-block w-100"
                            alt="Slide 4"
                            style={{ height: '600px', objectFit: 'cover', objectPosition: 'top' }}
                        />
                    </div>

                    <div className="carousel-item">
                        <img
                            src="/Photos/three-women-in-office.jpg"
                            className="d-block w-100"
                            alt="Slide 5"
                            style={{ height: '600px', objectFit: 'cover', objectPosition: 'center' }}
                        />
                    </div>

                </div>

                <button className="carousel-control-prev" type="button" data-bs-target="#imageCarousel" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>

                <button className="carousel-control-next" type="button" data-bs-target="#imageCarousel" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>

            <div className='container'>
                <h1>Welcome to Delight Consultancy</h1>
            </div>


            {/* Bootstrap container with left content and right image */}
            <div className="container my-5" id="welcome-page" data-aos="fade-up">
                <div className="row align-items-center">

                    {/* Left side content */}
                    <div className="col-md-6">
                        <h3 className='first-head'>Delight Consultancy</h3>
                        <p>Welcome to Delight Consultancy, your trusted partner in innovative technology and business solutions. We specialize in providing cutting-edge services designed to enhance your business performance, streamline operations, and boost productivity. With a focus on delivering exceptional results, we cater to clients across various industries.
                            <br></br>
                            <br></br>
                            Founded in 2004, Delight Consultancy has grown into a leading provider of [describe services such as IT solutions, consulting, software development, digital marketing, etc.]. Our mission is to help businesses navigate the complexities of the modern digital landscape and achieve sustainable growth.</p>
                        {/* <button className="btn btn-primary">Learn More</button> */}
                    </div>

                    {/* Right side image */}
                    <div className="col-md-6">
                        <img
                            src="/Photos/IT-Consulting-Can-Help-Your-Current-Business.png"
                            alt="Office"
                            className="img-fluid rounded"
                            style={{ maxHeight: '400px', width: '100%', objectFit: 'cover' }}
                        />
                    </div>
                </div>
            </div>
            <div className='container' data-aos="fade-up">
                <h3 className='second-head'>WHO WE ARE</h3>
                <div className='container'>
                    <p id='who'>12 years of PAN India Corporate Recruitment Experience in the IT & ITES industry. Expertise in 3 different Verticals. At Delight Consultancy, we are a dynamic and forward-thinking organization dedicated to empowering businesses through innovative recruitment and HR solutions. With a strong commitment to excellence, we specialize in connecting top talent with the right opportunities, ensuring mutual growth and success.</p>
                </div>
            </div>

            <div className="container my-5" id='three-plot' data-aos="fade-up">

                <div className="row">

                    <div className="col-md-4 mb-4">
                        <div className="row align-items-start">
                            <div className="col-auto">
                                <img
                                    src="/Photos/recruitment-best-practices-3.png"
                                    alt="Icon"
                                    className="img-fluid"
                                    style={{ maxWidth: '90px' }}
                                />
                            </div>
                            <div className="col">
                                <h5>Volume hiring</h5>
                                <p>
                                    Volume hiring is a strategic recruitment approach designed to efficiently professionals with specialized skills and expertise into mid-level or senior roles to address specific organizational needs.
                                </p>
                                <a href="https://delightconsultancy.in/contact"><button className='btn btn-primary btn-sm'>contact Us</button></a>
                            </div>
                        </div>
                    </div>

                    {/* Column 2 */}
                    <div className="col-md-4 mb-4">
                        <div className="row align-items-start">
                            <div className="col-auto">
                                <img
                                    src="/Photos/Recruitment-process.webp"
                                    alt="Icon"
                                    className="img-fluid"
                                    style={{ maxWidth: '90px' }}
                                />
                            </div>
                            <div className="col">
                                <h5> Lateral hiring</h5>
                                <p>
                                    Lateral hiring is a recruitment strategy aimed at bringing experienced professionals with specialized skills and expertise into mid-level or senior roles to address specific organizational needs.
                                </p>
                              <a href="https://delightconsultancy.in/career"><button className='btn btn-primary btn-sm'>Hire Now</button></a>
                            </div>
                        </div>
                    </div>

                    {/* Column 3 */}
                    <div className="col-md-4 mb-4">
                        <div className="row align-items-start">
                            <div className="col-auto">
                                <img
                                    src="/Photos/sdsfsdf.jpg"
                                    alt="Icon"
                                    className="img-fluid"
                                    style={{ maxWidth: '90px' }}
                                />
                            </div>
                            <div className="col">
                                <h5>Leadership hiring</h5>
                                <p>
                                    Leadership hiring is a focused recruitment approach to identify and attract senior executives or top-level professionals with strategic vision, decision-making expertise, and the ability to drive organizational growth.
                                </p>
                                 <a href="/"><button className='btn btn-primary btn-sm'>Get Started</button></a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="wave-section" data-aos="fade-up">
                <div className="container py-5">
                    {/* Section Title */}
                    <div id="services-div" className="text-center mb-4">
                        <h2 id="service">Our Services</h2>
                        <h3 className='text-white'>
                            At Delight Consultancy, we offer a comprehensive suite of services designed to empower businesses with innovative and customized solutions. Our core services include:
                        </h3>
                    </div>

                    {/* Services Grid */}
                    <div className="row g-4 justify-content-center" id="services-con">
                        {/* Block 1 */}
                        <div className="col-12 col-sm-6 col-md-4 d-flex justify-content-center">
                            <div className="block-box shadow" id="account">
                                <h4 className="box-text">Accounting / Finance</h4>
                            </div>
                        </div>

                        {/* Block 2 */}
                        <div className="col-12 col-sm-6 col-md-4 d-flex justify-content-center">
                            <div className="block-box shadow" id="bank">
                                <h4 className="box-text">Banking</h4>
                            </div>
                        </div>

                        {/* Block 3 */}
                        <div className="col-12 col-sm-6 col-md-4 d-flex justify-content-center">
                            <div className="block-box shadow" id="tech">
                                <h4 className="box-text">Technology</h4>
                            </div>
                        </div>

                        {/* Block 4 */}
                        <div className="col-12 col-sm-6 col-md-4 d-flex justify-content-center">
                            <div className="block-box shadow" id="web-dev">
                                <h4 className="box-text">Web Developer</h4>
                            </div>
                        </div>

                        {/* Block 5 */}
                        <div className="col-12 col-sm-6 col-md-4 d-flex justify-content-center">
                            <div className="block-box shadow" id="customer">
                                <h4 className="box-text">Customer Service</h4>
                            </div>
                        </div>

                        {/* Block 6 */}
                        <div className="col-12 col-sm-6 col-md-4 d-flex justify-content-center">
                            <div className="block-box shadow" id="digital">
                                <h4 className="box-text">Digital & Creative</h4>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div className='container' data-aos="fade-up">
                <h2 id='testimonial'>Testimonials</h2>
            </div>
            <div className="container my-5" id="testimonial-section" data-aos="fade-up">
                <div className="row align-items-center">
                    {/* Left Side Image */}
                    <div className="col-md-6 mb-4 mb-md-0">
                        <img
                            src="/Photos/what-is-recruitment-3.webp"
                            alt="Office"
                            className="img-fluid rounded"
                            style={{ maxHeight: '400px', width: '100%', objectFit: 'cover' }}
                        />
                    </div>

                    {/* Right Side Testimonials (Horizontal Slide) */}
                    <div className="col-md-6">
                        <h2 className="mb-4" id='client'>What Our Clients Say</h2>
                        <div id="testimonialCarousel" className="carousel slide" data-bs-ride="carousel">
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <div className="testimonial-box bg-light p-4 rounded shadow-sm">
                                        <p>"Working with Delight Consultancy transformed our business strategy. Their insights into market positioning and branding helped us stand out in a crowded space. Truly a game-changer for our growth."</p>
                                        <h6 className='text-dark'>- Aisha K.</h6>
                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <div className="testimonial-box bg-light p-4 rounded shadow-sm">
                                        <p>"Delight Consultancy built our website from the ground up and it turned out even better than we imagined. They understood our vision, executed quickly, and provided excellent support throughout the process."</p>
                                        <h6 className='text-dark'>- Raj P.</h6>
                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <div className="testimonial-box bg-light p-4 rounded shadow-sm">
                                        <p>"From digital marketing to automation tools, the team at Delight Consultancy delivered results that exceeded our expectations. Our lead generation has increased by 40% in just three months!"</p>
                                        <h6 className='text-dark'>- Maria L.</h6>
                                    </div>
                                </div>
                            </div>

                            {/* Controls */}
                            <button
                                className="carousel-control-prev"
                                type="button"
                                data-bs-target="#testimonialCarousel"
                                data-bs-slide="prev"
                            >
                                <span className="carousel-control-prev-icon-dark" aria-hidden="false" />
                                <span className="visually"></span>
                            </button>
                            <button
                                className="carousel-control-next"
                                type="button"
                                data-bs-target="#testimonialCarousel"
                                data-bs-slide="next"
                            >
                                <span className="carousel-control-next-icon" aria-hidden="false" />
                                <span className="visually"></span>
                            </button>
                        </div>
                    </div>
                </div>

            </div>
            <div className='container-fluid' id="business-page" data-aos="fade-up">
                <div className="container my-5">
                    <div className="row align-items-center">
                        {/* Left side content */}
                        <div className="col-md-6">
                            <h3 className='business-head'>We Build Lasting Relationships Between Candidates & Businesses</h3>
                            <p>At Delight Consultancy, we believe in building lasting relationships between candidates and businesses by fostering a strong, transparent, and collaborative approach. Our focus is not just on filling positions, but on creating meaningful connections that align with the values, goals, and culture of both parties. By understanding the unique needs of our clients and the aspirations of our candidates, we ensure that every placement is a long-term success, driving mutual growth and satisfaction. Through personalized service and a commitment to excellence, we continue to cultivate relationships that stand the test of time.</p>
                            {/* <button className="btn btn-primary">Learn More</button> */}
                        </div>

                        {/* Right side image */}
                        <div className="col-md-6">
                            <img
                                src="/Photos/The-Role-of-Executive-Communication-in-Effective-Employee-Recognition_Featur.png"
                                alt="Office"
                                className="img-fluid rounded"
                                style={{ maxHeight: '400px', width: '100%', objectFit: 'cover' }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="container py-5">
                <div className="row">
                    <div className='container' id='expert-team'>
                        <h3 id='expert-team-head'>Our Expert Team</h3>
                        <p className='expert-teamm'>At Delight Consultancy, our success is driven by the dedication, expertise, and passion of our talented team. We bring together professionals from diverse backgrounds who share a common commitment to delivering outstanding results.</p>
                    </div>

                    {/* Column 1 */}
                    <div className="col-md-4 mb-4">
                        <div className="d-flex flex-column align-items-center p-3 border rounded shadow-sm h-100" id="expert-image">
                            <div className="mb-3">
                                <img
                                    src="/Photos/5471.jpg"
                                    alt="Harrison Hudson"
                                    className="img-fluid rounded-circle"
                                    style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                                />
                            </div>
                            <div className="text-center">
                                <h5 className="mb-1">Harrison Hudson</h5>
                                <p className="">WordPress Dev.</p>
                            </div>
                            <div className="d-flex justify-content-center gap-3 mt-2">
                                <a href="https://facebook.com"><i className="fab fa-facebook text-primary"></i></a>
                                <a href="https://twitter.com"><i className="fab fa-twitter text-info"></i></a>
                                <a href="https://linkedin.com"><i className="fab fa-linkedin text-primary"></i></a>
                                <a href="https://youtube.com"><i className="fab fa-youtube text-danger"></i></a>
                            </div>
                        </div>
                    </div>

                    {/* Column 2 */}
                    <div className="col-md-4 mb-4">
                        <div className="d-flex flex-column align-items-center p-3 border rounded shadow-sm h-100" id="expert-image">
                            <div className="mb-3" >
                                <img
                                    src="/Photos/2672335.jpg"
                                    alt="Anna Smith"
                                    className="img-fluid rounded-circle"
                                    style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                                />
                            </div>
                            <div className="text-center">
                                <h5 className="mb-1">Anna Smith</h5>
                                <p className="">UI/UX Designer</p>
                            </div>
                            <div className="d-flex justify-content-center gap-3 mt-2">
                                <a href="/"><i className="fab fa-facebook text-primary"></i></a>
                                <a href="/"><i className="fab fa-twitter text-info"></i></a>
                                <a href="/"><i className="fab fa-linkedin text-primary"></i></a>
                                <a href="/"><i className="fab fa-youtube text-danger"></i></a>
                            </div>
                        </div>
                    </div>

                    {/* Column 3 */}
                    <div className="col-md-4 mb-4">
                        <div className="d-flex flex-column align-items-center p-3 border rounded shadow-sm h-100" id="expert-image">
                            <div className="mb-3">
                                <img
                                    src="/Photos/5278.jpg"
                                    alt="John Doe"
                                    className="img-fluid rounded-circle"
                                    style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                                />
                            </div>
                            <div className="text-center">
                                <h5 className="mb-1">John Doe</h5>
                                <p className="">Full Stack Dev.</p>
                            </div>
                            <div className="d-flex justify-content-center gap-3 mt-2">
                                <a href="/"><i className="fab fa-facebook text-primary"></i></a>
                                <a href="/"><i className="fab fa-twitter text-info"></i></a>
                                <a href="/"><i className="fab fa-linkedin text-primary"></i></a>
                                <a href="/"><i className="fab fa-youtube text-danger"></i></a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className='container-fluid' id='mission' data-aos="fade-up">
                <div className='container' id='mission-heading'>
                    <div className='row'>
                        <div className='col-md-6' id='mission-con'>
                            <h3 className='mission-head'>Our Vision</h3>
                            <p className='vission-para'>At Delight Consultancy, our vision is to be recognized as the leading provider of innovative, high-quality talent solutions that help organizations thrive. We aim to create a world where businesses and professionals are perfectly aligned, fostering lasting partnerships that drive mutual growth, success, and transformation. By anticipating future workforce trends and embracing change, we strive to empower both organizations and talent to unlock their fullest potential.</p>
                        </div>


                        <div className='col-md-6' id='vission-con'>
                            <h3 className='mission-head'>Our mission</h3>
                            <p>Our mission is to deliver tailored recruitment and HR solutions that meet the dynamic needs of businesses and candidates. We are committed to helping companies find the right talent at the right time, ensuring a perfect fit for long-term success. Through a deep understanding of each client’s goals, we build meaningful, sustainable relationships that contribute to organizational growth and the advancement of careers. We embrace innovation, collaboration, and integrity to deliver services that make a real difference in the recruitment and HR landscape.</p>
                        </div>
                    </div>

                </div>
            </div>
            <div className="container my-5" data-aos="fade-up">
                <div className="row">
                    <div>
                        <h2 className='blog'>Our Blog</h2>
                    </div>
                    {/* Column 1 */}
                    <div className="col-md-4 mb-4">
                        <div className="card h-100 shadow-sm">
                            <img src="/Photos/19375.jpg" height={300} className="card-img-top" alt="Blog 1" />
                            <div className="card-body">
                                <h5 className="card-title-bold">Top 5 Hiring Trends to Watch in 2025</h5>
                                <p className="card-text">
                                    Hiring is evolving fast—and staying ahead of trends is crucial. At Delight Consultancy, we help clients adapt to changes in recruitment. Here are five hiring shifts we’re seeing in 2025—and how to use them to your advantage.
                                </p>
                                <a href="/" className="btn btn-primary">Read More</a>
                            </div>
                        </div>
                    </div>

                    {/* Column 2 */}
                    <div className="col-md-4 mb-4">
                        <div className="card h-100 shadow-sm">
                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvGQ-Eop7LfeGvpI24KIS_grarmVAjUsgoEoGNgAIK883AzjD1fpf9nlendpHLRjJWoNw&usqp=CAU" height={300} className="card-img-top" alt="Blog 2" />
                            <div className="card-body">
                                <h5 className="card-title-bold">Why Working with a Recruitment Consultancy Saves Time and Money</h5>
                                <p className="card-text">
                                    Hiring the right candidate can be a time-consuming and costly process—especially if it goes wrong. That’s where recruitment consultancies like Delight Consultancy come in.
                                </p>
                                <a href="/" className="btn btn-primary">Read More</a>
                            </div>
                        </div>
                    </div>

                    {/* Column 3 */}
                    <div className="col-md-4 mb-4">
                        <div className="card h-100 shadow-sm">
                            <img src="https://www.bizneo.com/blog/wp-content/uploads/2019/10/comunicacion-interna.jpg" className="card-img-top" alt="Blog 3" height={300} />
                            <div className="card-body">
                                <h5 className="card-title-bold">How to Build a CV That Gets You Hired in 2025</h5>
                                <p className="card-text">
                                    Your CV is your first impression—and in a competitive job market, it needs to stand out instantly. At Delight Consultancy, we review hundreds of CVs every month, and we know exactly what recruiters look .
                                </p>
                                <a href="/" className="btn btn-primary">Read More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='container-fluid' id='contact-div' data-aos="fade-up">
                <div className='container' >
                    <div>
                        <h2 className='contact'>We’ve worked with some great companies already. We think you<br></br>
                            should join them in your quest for top talent.</h2>

                    </div>


                </div>
                <div className='contact-button'>
                    <a href="https://delightconsultancy.in/contact"><button className='contact-btn'>contact</button></a>
                </div>
            </div>




        </div >



    );
};

export default Home;
